import type { SlugNode } from '@/lib/slug-rewrites';

/** es/ca/it are deliberately the words `old/contact.meta.ts` served — see slug-rewrites. */
export const routeName = 'contact';
export const slugs: Record<string, string> = {
	es: 'contacto',
	en: 'contact',
	ca: 'contacte',
	fr: 'contact',
	it: 'contatto',
};

/**
 * The path segments below this page: the four audience questionnaires, and the one tab that has a URL
 * of its own — an NGO's "I want to ask", which is a form, unlike the sign-up CTA it sits beside.
 *
 * They live here, beside the parent's own slugs, because the same three consumers read both — the
 * router's rewrite, the language switcher and the canonical/hreflang builder. A segment declared
 * anywhere else would be the one part of the URL those three could disagree about.
 *
 * The KEY is the internal name (what the route's `$audience`/`$tab` param carries and what a `<Link>`
 * names, so no caller needs to know the locale); `slugs` is the word each locale puts in the URL.
 *
 * `collaborate`, the NGO's other tab, is deliberately absent: it is the default, so it owns the bare
 * `/contacto/ong` and a second URL for it would be the same page under two addresses.
 */
export const children: Record<string, SlugNode> = {
	company: { slugs: { es: 'empresas', en: 'companies', ca: 'empreses', fr: 'entreprises', it: 'aziende' } },
	ngo: {
		slugs: { es: 'ong', en: 'ngos', ca: 'ong', fr: 'ong', it: 'ong' },
		children: {
			enquire: { slugs: { es: 'consulta', en: 'enquiry', ca: 'consulta', fr: 'demande', it: 'richiesta' } },
		},
	},
	donor: { slugs: { es: 'donantes', en: 'donors', ca: 'donants', fr: 'donateurs', it: 'donatori' } },
	press: { slugs: { es: 'prensa', en: 'press', ca: 'premsa', fr: 'presse', it: 'stampa' } },
};

export const sitemap = { changefreq: 'monthly', priority: '0.7', lastmod: '2026-08-21' };
